// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__QCbTt","footer":"ModalUpdate_footer__3hTu8"};